import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FilterOptions } from '../../types/filter.types';
import { Filter } from '../../types/OilsFIlter.types';
import { RootState } from '../store';

type FiltersState = {
  [filter in Filter]: FilterOptions;
};

const initialState: FiltersState = {
  country: { value: '', options: [], label: '' },
  application: { value: '', options: [], label: '' },
  subapplication: { value: '', options: [], label: '' },
  series: { value: '', options: [], label: '' },
  homoAndMiss: { value: '', options: [], label: '' },
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateValue: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: Filter; value: string }>
    ) => {
      state[filter].value = value;
    },
    updateOptions: (
      state,
      {
        payload: { filter, options },
      }: PayloadAction<{ filter: Filter; options: FilterOptions['options'] }>
    ) => {
      state[filter].options = options;
    },
    updateLabels: (
      state,
      { payload }: PayloadAction<{ [filter in Filter]: string }>
    ) => {
      const newState = { ...state };

      Object.keys(payload).forEach((filter: Filter) => {
        newState[filter].label = payload[filter];
      });

      state = newState;
    },
    resetFilter: (state, { payload: filter }: PayloadAction<Filter>) => {
      state[filter] = { value: '', options: [], label: state[filter].label };
    },
  },
});

export const { updateValue, updateOptions, updateLabels, resetFilter } =
  filtersSlice.actions;

export const getFilters = (state: RootState) => state.filters;

export default filtersSlice.reducer;
